<template>
  <!--产品技术页面-->
  <div class="productPage">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="imgBoxUrl" class="el-image__inner">
      </div>
      <!--      <div class="imgText">
              <div>产品介绍</div>
              <div>YAG激光治疗仪YAG激光治疗仪YAG激光治疗仪YAG</div>
            </div>-->
    </div>
    <!--    导航-->
    <div class="num_all">
      <el-row >
        <el-col :span="18" :justify="end" ><div class="grid-content num_r">
          <el-menu :default-active="numIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item  v-for="item in numList" :index="item.num" :indexPath="item.path">{{item.tital}}</el-menu-item>
          </el-menu>
        </div></el-col>
      </el-row>
    </div>
    <!--    内容-->
    <div class="contentBox"  v-show="showData.box1">
      <div class="contentTitle">
        {{product1.text1}}
      </div>
      <div class="contentImg">
        <div class="leftImg">
          <el-image
            style="width: 578px; height: 700px"
            :src="product1.img1"
            :fit="contain"></el-image>
        </div>
        <div class="rightImg">
          <div class="rightTopImg">

            <el-image
              style="width: 578px; height: 340px"
              :src="product1.img2"
              :fit="contain"></el-image>
          </div>
          <div class="rightBottomImg">
            <el-image
              style="width: 578px; height: 340px"
              :src="product1.img3"
              :fit="contain"></el-image>
          </div>
        </div>

      </div>
      <div class="contentDetail">
        <div class="itemTitle">{{product1.text2}}</div>
        <el-divider></el-divider>
        <div class="itemContent">
          {{product1.text3}}
        </div>
      </div>
    </div>

    <div class="contentBox"  v-show="showData.box2">
      <div class="contentTitle">
        {{product2.text1}}
      </div>
      <div class="contentImg">
        <div class="leftImg">
          <el-image
            style="width: 578px; height: 700px"
            :src="product2.img1"
            :fit="contain"></el-image>
        </div>
        <div class="rightImg">
          <div class="rightTopImg">

            <el-image
              style="width: 578px; height: 340px"
              :src="product2.img2"
              :fit="contain"></el-image>
          </div>
          <div class="rightBottomImg">
            <el-image
              style="width: 578px; height: 340px"
              :src="product2.img3"
              :fit="contain"></el-image>
          </div>
        </div>
        </div>
      <div class="contentDetail">
        <div class="itemTitle">{{product2.text2}}</div>
        <el-divider></el-divider>
        <div class="itemContent">
          {{product2.text3}}
        </div>
      </div>
    </div>


    <div class="contentBox"  v-show="showData.box3" >
      <div class="contentTitle">
        {{product3.text1}}
      </div>
      <div class="contentImg">
        <div class="leftImg">
          <el-image
            style="width: 578px; height: 700px"
            :src="product3.img1"
            :fit="contain"></el-image>
        </div>
        <div class="rightImg">
          <div class="rightTopImg">

            <el-image
              style="width: 578px; height: 340px"
              :src="product3.img2"
              :fit="contain"></el-image>
          </div>
          <div class="rightBottomImg">
            <el-image
              style="width: 578px; height: 340px"
              :src="product3.img3"
              :fit="contain"></el-image>
          </div>
        </div>
        </div>
      <div class="contentDetail">
        <div class="itemTitle">{{product3.text2}}</div>
        <el-divider></el-divider>
        <div class="itemContent">
          {{product3.text3}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mun2 from "./image/mun2";
export default {
  name: "product",
  components: {Mun2},
  data() {
    return {
      imgBoxUrl:"http://116.62.38.250//image//nr/tp/cpjs.jpg",
      urlData:"",
      showData:{
        box1: false,
        box2: false,
        box3: false
      },
      numIndex: "1",
      numList : [
        {
          num : "1",
          tital : "Product Technology",
          path: "cpjs"
        },
        {
          num : "2",
          tital : "All-in-One",
          path: "gzj"
        },
        {
          num : "3",
          tital : "Working Tips",
          path: "sb"
        }
      ],
      product1:{
        text1:"Er:YAG Dental Laser Treatment System",
        text2:"Er:YAG Dental Laser Treatment System",
        text3:"Utilizing military-grade Er:YAG crystals, this system generates a 2940nm wavelength laser. Through dynamic focusing technology in the handpiece, it interacts with the water molecules in oral tissues, creating a \"micro-explosion\" effect that enables vaporization, ablation, and cutting of both soft and hard tissues in the oral cavity.\n" +
          "The Er:YAG dental laser has minimal impact on the surface temperature of tissues, making it one of the most efficient, safe, and minimally invasive treatment options available in the field of dental laser therapy today.\n" +
          "This system can be widely applied across various dental disciplines, with significant clinical advantages in periodontics, implantology, orthodontics, aesthetics, and pediatric dentistry.",
        img1:"http://116.62.38.250//image/nr/cpjs/1.jpg",
        img2:"http://116.62.38.250//image/nr/cpjs/1-1.jpg",
        img3:"http://116.62.38.250//image/nr/cpjs/1-2.jpg",


      },
      product2:{
        text1:"All-in-One Laser Handpiece",
        text2:"All-in-One Laser Handpiece",
        text3:"This device features a straight and angled head design, allowing for full-range, multi-angle treatment. It supports 360-degree free rotation, offering excellent flexibility and maneuverability, significantly enhancing ease of use. The handpiece contains a built-in laser generator and is equipped with third-generation direct energy transmission technology, ensuring 100% laser energy transmission without any loss.\n" +
          "It eliminates the need for fiber optics, articulated arms, or high-maintenance consumable components, reducing equipment failure rates and simplifying maintenance. Additionally, its compact size makes it easy to move, improving the device's usage rate and treatment efficiency.",
        img1:"http://116.62.38.250//image/nr/cpjs/2.jpg",
        img2:"http://116.62.38.250//image/nr/cpjs/2-1.jpg",
        img3:"http://116.62.38.250//image/nr/cpjs/2-2.jpg",


      },
      product3:{
        text1:"Laser Working Tips",
        text2:"Laser Working Tips",
        text3:"(3)The non-invasive, lock-in design allows for easy, plug-and-play use. Available in various diameters and lengths, the tips are autoclavable for high-temperature sterilization, enabling repeated use and significantly reducing operational costs.",
        img1:"http://116.62.38.250//image/nr/cpjs/3.png",
        img2:"http://116.62.38.250//image/nr/cpjs/3-1.jpg",
        img3:"http://116.62.38.250//image/nr/cpjs/3-2.jpg",


      }
    }
  },
  mounted() {
    let that = this;
    console.log("init");
    that.init();
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);

  },
  methods: {
    init(){
      let that = this;
      console.log(that.urlData);
      console.log(that.urlData == undefined);
      if(that.urlData == "" || that.urlData == undefined){
        that.handleSelect("1",'cpjs')
      } else {
        let index = "1";
        if(that.urlData == 'cpjs'){
          index = "1";
        } else if (that.urlData == 'gzj'){
          index = "2";
        } else if (that.urlData == 'sb'){
          index = "3";
        }

        that.handleSelect(index,that.urlData)
      }

    },

    handleSelect(index, path) {
      let that = this;
      that.numIndex = index;
      console.log(index+path)  //获取tab标签的选中值
      console.log(index, path);
      //初始化
      that.showData.box1 = false;
      that.showData.box2= false;
      that.showData.box3 = false;

      if(index == '1'){
        that.showData.box1 = true;
      } else if (index == '2'){
        that.showData.box2 = true;
      } else if (index == '3'){
        that.showData.box3 = true;
      }
    }
  }
}
</script>

<style scoped>
.num_all{
  background: #ffffff;
  font-family: SourceHanSansCN;
  font-size: 12px;
  text-align: justify;
  height: 60px;
  width: 100%;
}
.num_r{
  float: right;
}
.contentTitle{
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #333333;
  text-align: justify;
}
.productPage {
  display: block;
  width: 1920px;
  background-color: #FFFFFF;
}

.imgBox {
  width: 100%;
  height: 600px;
}

.imageItem {
  height: 100%;
}

.menuBox {
  width: 100%;
  height: 60px;
  background: #F3F4F8;
}

.contentBox {
  width: 1176px;
  /*height: 700px;*/
  margin: 50px auto;
}

.contentImg {
  margin-top: 50px;
  margin-bottom: 50px;
  width: 970px;
  height: 700px;
  display: flex;
}

.leftImg, .rightImg {
  width: 578px;
  height: 700px;
}
.rightTopImg {
  border-radius: 10px;
  width: 578px;
  height: 340px;
  margin-bottom: 20px;
  margin-left: 10px;
}

.rightBottomImg {
  border-radius: 10px;
  width: 578px;
  height: 340px;
  margin-left: 10px;
}

.img1 {
  width: 100%;
  border-radius: 10px;
}

.itemTitle {
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #333333;
  text-align: justify;
  height: 50px;
}

.itemContent {
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #666666;
  letter-spacing: 0.39px;
  text-align: justify;
  line-height: 32px;
}

</style>



// WEBPACK FOOTER //
// src/components/en/product.vue